module.exports = __webpack_public_path__ + "img/lg_ring_r_c_null_0.2d1ec963.png";